<template>
  <div class="container">
    <div v-if="
      showHome &&
      showHomes &&
      showBoard &&
      showPhoneNews &&
      showCleanGover &&
      showTextAll &&
      showSerachInfo &&
      showSerachInfos &&
      showDeptList &&
      ShowBusiness
    ">
      <div class="leftImg" v-show="leftImgShow" id="floatingWindow" :class="{ 'no-animation': isHovered }"
        @mouseenter="pauseAnimation" @mouseleave="resumeAnimation">
        <div v-for="(item, index) in suspendList" :key="index" style="width: 200px; height: 60px">
          <img @click="goToCol(item)" :src="item.image" alt="" />
        </div>
        <div class="hover-underline close" @click="leftImgShow = false" v-if="suspendList.length">
          关闭
          <img src="../../assets/images/close.png" alt="" />
        </div>
      </div>
      <div class="dataBox">
        <div class="date" style="margin-bottom: 5px">
          <div class="dateWidth">{{ date }}</div>
          <div class="red" style="width: 90px">[ 今日值班 ]</div>
          <!--  -->
          <div style="width: 138px"  v-if="todayDuty.dbld">
            <div>
              {{ dutyconfig[0].post }}：<span>{{ todayDuty.dbld }}</span>
            </div>
          </div>
          <div style="width: 138px" v-if="dutyconfig[0].post">
            {{ dutyconfig[1].post }}：<span>{{ todayDuty.zbld }}</span>
          </div>
          <div style="width: 138px" v-if="dutyconfig[0].post">
            {{ dutyconfig[2].post }}：<span>{{ todayDuty.zhz }}</span>
          </div>
          <div style="width: 138px" v-if="dutyconfig[0].post">
            {{ dutyconfig[3].post }}：<span>{{ todayDuty.zzzhz }}</span>
          </div>
          <div style="width: 138px" v-if="dutyconfig[0].post">
            {{ dutyconfig[4].post }}：<span>{{ todayDuty.aqzl }}</span>
          </div>
          <div style="width: 138px"  v-if="!todayDuty.dbld">

          </div>
          <!-- <div class="red">更多 >></div> -->
          <div class="linkage-right">
            <input type="text" placeholder="请输入" v-model="searchValue" class="no-outline-input" />
            <div class="button" @click="istrue">
              <img src="../../assets/images/search.png" alt="" />
            </div>
          </div>
        </div>
        <div class="date" style="margin-bottom: 16px">
          <div class="dateWidth">{{ weekday }}</div>
          <div class="red hover-underline" style="width: 90px" @click="showTextAll = false">
            [ 更多值班 ]
          </div>
          <div style="width: 138px" v-if="dutyconfig[0].post">
            {{ dutyconfig[5].post }}：<span>{{ todayDuty.zbzb }}</span>
          </div>
          <div style="width: 138px" v-if="dutyconfig[0].post">
            {{ dutyconfig[6].post }}：<span>{{ todayDuty.zxzb }}</span>
          </div>
          <div style="width: 138px" v-if="dutyconfig[0].post">
            {{ dutyconfig[7].post }}：<span>{{ todayDuty.zbz }}</span>
          </div>
          <div style="width: 138px" v-if="dutyconfig[0].post">
            {{ dutyconfig[8].post }}：<span>{{ todayDuty.yjtxy }}</span>
          </div>
          <div style="width: 138px" v-if="dutyconfig[0].post">
            {{ dutyconfig[9].post }}：<span>{{ todayDuty.jsy }}</span>
          </div>
          <!-- <div class="red">更多 >></div> -->
          <div class="linkage-right hover-underline" style="justify-content: flex-end; color: #155093"
            @click="gowaizhan('http://59.203.194.85/index.jsp')">
            <div>回归旧版</div>
          </div>
        </div>
      </div>
      <div class="content">
        <!-- <div class="left"> -->
        <div class="content-left-top">
          <div class="swiper">
            <div class="carousel" @mouseenter="stopCarousel" @mouseleave="startCarousel">
              <div class="carousel-image">
                <img @click="goimgInfo(bannerList[currentIndex])" :src="bannerList[currentIndex].annexUrl"
                  :alt="bannerList[currentIndex].id" />
              </div>
              <div class="indicators">
                <span v-for="(item, index) in bannerList" :key="index" class="indicator"
                  :class="{ active: index === currentIndex }" @click="currentIndex = index">
                  {{ index + 1 }}
                </span>
              </div>
            </div>
            <div class="title">
              {{ bannerList[currentIndex].messageName }}
            </div>
          </div>
          <div class="sec-right">
            <div class="sec-right-title">
              <div class="tag">
                <img src="../../assets/images/tag.png" alt="" />
                <span>消防要闻</span>
              </div>
              <div class="more-box" @click="gengduo(0)">
                <div class="more">更多 >></div>
              </div>
            </div>

            <ul class="custom-list">
              <li v-for="(item, index) in zeroList" :key="index" @click="goInfo(item)">
                <div class="li-content">
                  <div style="display: flex">
                    <div class="custom-link hover-underline">
                      <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                        :open-delay="500">
                        <div class="custom-link-zero">{{ item.messageName }}</div>
                      </el-tooltip>
                    </div>

                  </div>
                  <div v-if="newsDate == item.releaseTime">
                    <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                  </div>
                  <div v-else>
                    <span class="red" v-if="item.isTop == 1">置顶 </span>
                    <span v-else>[{{
                      item.releaseTime
                    }}]</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="content-right-top mar-bot" style="padding: 0 12px">
            <div class="right-tab">
              <div class="right-text">通知栏</div>
              <div class="right-more" @click="gengduo(16)">更多>></div>
            </div>
            <ul class="custom-list" style="margin-top: ">
              <li v-for="(item, index) in sixteen" :key="index" style="margin: 10px 0; padding-left: 20px"
                @click="goInfo(item)">
                <div class="li-content">
                  <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                    <div class="custom-link hover-underline" style="display: flex">
                      <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                        :open-delay="500">
                        <div class="custom-link-text3">{{ item.messageName }}</div>
                      </el-tooltip>
                      
                    </div>
                    <div v-if="newsDate == item.releaseTime">
                      <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="content-left-sec">
          <div class="content-left-sec-left">
            <div class="sec-right-title">
              <div class="tag">
                <img src="../../assets/images/chang.png" alt="" />
                <div class="wenjian">
                  <div :class="['shou', checkwj == 1 ? 'shangji' : 'shangji2']" @click="checkwjbt()">
                    上级文件
                  </div>
                  <div :class="['shou', checkwj == 2 ? 'zhidui2' : 'zhidui']" @click="checkwjbt2()">
                    支队文件
                  </div>
                </div>
              </div>
              <div class="more-box" @click="gengduo(18)">
                <div class="more">更多 >></div>
              </div>
            </div>
            <ul class="custom-list" v-if="checkwj == 1">
              <li v-for="(item, index) in List17" :key="index" @click="goInfo(item)">
                <div class="li-content">
                  <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                    <div class="custom-link hover-underline" style="display: flex">
                      <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                        :open-delay="500">
                        <div class="custom-link-text">{{ item.messageName }}</div>
                      </el-tooltip>

                    </div>

                    <div v-if="newsDate == item.releaseTime">
                      <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                    </div>
                    <div v-else>
                      <span>[{{
                        item.releaseTime
                      }}]</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="custom-list" v-if="checkwj == 2">
              <li v-for="(item, index) in List18" :key="index" @click="goInfo(item)">
                <div class="li-content">
                  <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                    <div class="custom-link hover-underline" style="display: flex">
                      <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                        :open-delay="500">
                        <div class="custom-link-text">{{ item.messageName }}</div>
                      </el-tooltip>

                    </div>

                    <div v-if="newsDate == item.releaseTime">
                      <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                    </div>
                    <div v-else>
                      <span>[{{
                        item.releaseTime
                      }}]</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="content-left-sec-left" style="margin: 0 12px">
            <div class="sec-right-title">
              <div class="tag">
                <img src="../../assets/images/tag.png" alt="" />
                <span>机关动态</span>
              </div>
              <div class="more-box" @click="gengduo(2)">
                <div class="more">更多 >></div>
              </div>
            </div>
            <ul class="custom-list">
              <li v-for="(item, index) in twoList" :key="index" @click="goInfo(item)">
                <div class="li-content">
                  <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                    <div class="custom-link hover-underline" style="display: flex">
                      <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                        :open-delay="500">
                        <div class="custom-link-text">{{ item.messageName }}</div>
                      </el-tooltip>

                    </div>

                    <div v-if="newsDate == item.releaseTime">
                      <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                    </div>
                    <div v-else>
                      <span>[{{
                        item.releaseTime
                      }}]</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- 专题专栏 -->
          <div class="content-right-top mar-bot">
            <div class="top-text">
              <div class="blue" :class="{ active: elevenShow }" @click="toggleView">
                工作督办
              </div>
              <div class="blue" :class="{ active: !elevenShow }" @click="toggleViews">
                会议纪要
              </div>
            </div>
            <ul class="custom-list" v-show="elevenShow">
              <li v-for="(item, index) in thirteenList" :key="index" style="margin: 10px 0" @click="goInfo(item)">
                <div class="li-content">
                  <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                    <div class="custom-link hover-underline" style="display: flex">
                      <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                        :open-delay="500">
                        <div class="custom-link-text3">{{ item.messageName }}</div>
                      </el-tooltip>
                     
                    </div>
                    <div v-if="newsDate == item.releaseTime">
                      <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="custom-list" v-show="!elevenShow">
              <li v-for="(item, index) in twelveList" :key="index" style="margin: 10px 0" @click="goInfo(item)">
                <div class="li-content">
                  <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                    <div class="custom-link hover-underline" style="display: flex">
                      <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                        :open-delay="500">
                        <div class="custom-link-text3">{{ item.messageName }}</div>
                      </el-tooltip>
                     
                    </div>
                    <div v-if="newsDate == item.releaseTime">
                      <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="content-left-sec">
          <div style="width: 76%">
            <div class="sec-right-title thr">
              <div class="tag long-tag">
                <img src="../../assets/images/long-tag.png" alt="" />
                <span>基层动态</span>
              </div>
              <div class="more-box" @click="goDept('贵池')">
                <div class="more">更多 >></div>
              </div>
            </div>
            <div class="content-left-thr-content">
              <div class="content-left-thr-left">
                <div class="row" style="margin-top: 2px; margin-left: 12px">
                  <div class="row-left hover-underlines" @click="goDept('贵池')">
                    <span style="margin: 0; padding: 0">贵</span>
                    <span style="margin: 0; padding: 0">池 :</span>
                  </div>
                  <div class="row-right">
                    <div class="li-content my-li" v-for="(item, index) in guichi" :key="index" @click="goInfo(item)">
                      <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                        <div class="custom-link hover-underline" style="display: flex">
                          <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                            :open-delay="500">
                            <div class="custom-link-text2">{{ item.messageName }}</div>
                          </el-tooltip>

                        </div>
                        <div v-if="newsDate == item.releaseTime">
                          <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                        </div>
                        <div v-else>
                          <span>[{{
                            item.releaseTime
                            }}]</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 2px; margin-left: 12px">
                  <div class="row-left hover-underlines" @click="goDept('石台')">
                    <span>石</span>
                    <span>台 :</span>
                  </div>
                  <div class="row-right">
                    <div class="li-content my-li" v-for="(item, index) in shitai" :key="index" @click="goInfo(item)">
                      <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                        <div class="custom-link hover-underline" style="display: flex">
                          <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                            :open-delay="500">
                            <div class="custom-link-text2">{{ item.messageName }}</div>
                          </el-tooltip>

                        </div>
                        <div v-if="newsDate == item.releaseTime">
                          <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                        </div>
                        <div v-else>
                          <span>[{{
                            item.releaseTime
                            }}]</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 2px; margin-left: 12px">
                  <div class="row-left hover-underlines" @click="goDept('九华山')">
                    <span>九</span>
                    <span>华</span>
                    <span>山 :</span>
                  </div>

                  <div class="row-right">
                    <div class="li-content my-li" v-for="(item, index) in jiuhuashan" :key="index"
                      @click="goInfo(item)">
                      <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                        <div class="custom-link hover-underline" style="display: flex">
                          <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                            :open-delay="500">
                            <div class="custom-link-text2">{{ item.messageName }}</div>
                          </el-tooltip>

                        </div>
                        <div v-if="newsDate == item.releaseTime">
                          <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                        </div>
                        <div v-else>
                          <span>[{{
                            item.releaseTime
                            }}]</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content-left-thr-left content-left-right">
                <div class="row" style="margin-top: 2px">
                  <div class="row-left hover-underlines" @click="goDept('东至')">
                    <span>东</span>
                    <span>至 :</span>
                  </div>

                  <div class="row-right">
                    <div class="li-content my-li" v-for="(item, index) in dongzhi" :key="index" @click="goInfo(item)">
                      <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                        <div class="custom-link hover-underline" style="display: flex">
                          <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                            :open-delay="500">
                            <div class="custom-link-text2">{{ item.messageName }}</div>
                          </el-tooltip>

                        </div>
                        <div v-if="newsDate == item.releaseTime">
                          <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                        </div>
                        <div v-else>
                          <span>[{{
                            item.releaseTime
                            }}]</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 2px">
                  <div class="row-left hover-underlines" @click="goDept('青阳')">
                    <span>青</span>
                    <span>阳 :</span>
                  </div>
                  <div class="row-right">
                    <div class="li-content my-li" v-for="(item, index) in qingyang" :key="index" @click="goInfo(item)">
                      <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                        <div class="custom-link hover-underline" style="display: flex">
                          <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                            :open-delay="500">
                            <div class="custom-link-text2">{{ item.messageName }}</div>
                          </el-tooltip>

                        </div>
                        <div v-if="newsDate == item.releaseTime">
                          <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                        </div>
                        <div v-else>
                          <span>[{{
                            item.releaseTime
                            }}]</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 2px">
                  <div class="row-left hover-underlines" @click="goDept('特勤')">
                    <span>特</span>
                    <span>勤 :</span>
                  </div>
                  <div class="row-right">
                    <div class="li-content my-li" v-for="(item, index) in teqin" :key="index" @click="goInfo(item)">
                      <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                        <div class="custom-link hover-underline" style="display: flex">
                          <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                            :open-delay="500">
                            <div class="custom-link-text2">{{ item.messageName }}</div>
                          </el-tooltip>

                        </div>
                        <div v-if="newsDate == item.releaseTime">
                          <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                        </div>
                        <div v-else>
                          <span>[{{
                            item.releaseTime
                            }}]</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 工作简报 -->
          <div class="content-right-four content-right-sec mar-bot" style="margin-left: 12px">
            <div style="height: 228px">
              <div class="right-tab" style="margin-bottom: 6px">
                <div class="right-text">专题专栏</div>
                <div class="right-more"></div>
              </div>
              <div style="
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-around;
                  align-content: center;
                  padding: 0px 12px;
                ">
                <!-- @click="goToColZt(item)" -->
                <div v-for="(item, index) in columnZtList" :key="index" @click="open2(item)" :style="{
                  'background-image': `url(${item.bgUrl})`,
                }" class="zhuantu" style="cursor: pointer;">
                  <div style="color: #FF5050;font-weight: bold;">{{ item.name }}</div>
                </div>
              </div>
            </div>
            <div style="height: 214px">
              <div class="right-tab">
                <div class="right-text">工作简报</div>
                <div class="right-more" @click="gengduo(9)">更多>></div>
              </div>
              <ul class="custom-lists">
                <li v-for="(item, index) in nineList" :key="index" @click="goInfo(item)">
                  <div class="li-content wid">
                    <div style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                      ">
                      <div class="custom-link hover-underline" style="display: flex">
                        <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                          :open-delay="500">
                          <div class="custom-link-text3">{{ item.messageName }}</div>
                        </el-tooltip>

                      </div>
                      <div v-if="newsDate == item.releaseTime">
                        <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="content-left-sec">
          <div class="content-left-sec-left">
            <div class="sec-right-title">
              <div class="tag">
                <img src="../../assets/images/tag.png" alt="" />
                <span>灾情速递</span>
              </div>
              <div class="more-box">
                <div class="more" @click="gengduo(4)">更多 >></div>
              </div>
            </div>
            <ul class="custom-list">
              <li v-for="(item, index) in fourList" :key="index" @click="goInfo(item)">
                <div class="li-content">
                  <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                    <div class="custom-link hover-underline" style="display: flex">
                      <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                        :open-delay="500">
                        <div class="custom-link-text">{{ item.messageName }}</div>
                      </el-tooltip>

                    </div>
                    <div v-if="newsDate == item.releaseTime">
                      <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                    </div>
                    <div v-else>
                      <span>[{{
                        item.releaseTime
                      }}]</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="content-left-sec-left" style="margin: 0 12px">
            <div class="sec-right-title">
              <div class="tag">
                <img src="../../assets/images/tag.png" alt="" />
                <span>媒体聚焦 </span>
              </div>
              <div class="more-box">
                <div class="more" @click="gengduo(5)">更多 >></div>
              </div>
            </div>
            <ul class="custom-list">
              <li v-for="(item, index) in fiveList" :key="index" @click="goInfo(item)">
                <div class="li-content">
                  <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                    <div class="custom-link hover-underline" style="display: flex">
                      <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                        :open-delay="500">
                        <div class="custom-link-text">{{ item.messageName }}</div>
                      </el-tooltip>

                    </div>
                    <div v-if="newsDate == item.releaseTime">
                      <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                    </div>
                    <div v-else>
                      <span>[{{
                        item.releaseTime
                      }}]</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="content-right-four content-right-sec mar-bot" style="height: 164px">
            <div class="right-tab">
              <div class="right-text">工作计划</div>
              <div class="right-more" @click="gengduo(10)">更多>></div>
            </div>
            <ul class="custom-list">
              <li v-for="(item, index) in tenList" :key="index" @click="goInfo(item)">
                <div class="li-content wid">
                  <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                    <div class="custom-link hover-underline" style="display: flex">
                      <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                        :open-delay="500">
                        <div class="custom-link-text3">{{ item.messageName }}</div>
                      </el-tooltip>

                    </div>
                    <div v-if="newsDate == item.releaseTime">
                      <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                    </div>

                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="content-left-sec" style="height: 184px">
          <div class="content-left-sec-left" style="height: 184px">
            <div class="sec-right-title">
              <div class="tag">
                <img src="../../assets/images/tag.png" alt="" />
                <span>调研专题</span>
              </div>
              <div class="more-box">
                <div class="more" @click="gengduo(6)">更多 >></div>
              </div>
            </div>
            <ul class="custom-list">
              <li v-for="(item, index) in sixList" :key="index" @click="goInfo(item)">
                <div class="li-content">
                  <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                    <div class="custom-link hover-underline" style="display: flex">
                      <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                        :open-delay="500">
                        <div class="custom-link-text">{{ item.messageName }}</div>
                      </el-tooltip>

                    </div>
                    <div v-if="newsDate == item.releaseTime">
                      <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                    </div>
                    <div v-else>
                      <span>[{{
                        item.releaseTime
                      }}]</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="content-left-sec-left" style="margin: 0 12px; height: 184px">
            <div class="sec-right-title">
              <div class="tag">
                <img src="../../assets/images/tag.png" alt="" />
                <span>他山之石 </span>
              </div>
              <div class="more-box">
                <div class="more" @click="gengduo(7)">更多 >></div>
              </div>
            </div>
            <ul class="custom-list">
              <li v-for="(item, index) in sevenList" :key="index" @click="goInfo(item)">
                <div class="li-content">
                  <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                    <div class="custom-link hover-underline" style="display: flex">
                      <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                        :open-delay="500">
                        <div class="custom-link-text">{{ item.messageName }}</div>
                      </el-tooltip>

                    </div>
                    <div v-if="newsDate == item.releaseTime">
                      <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                    </div>
                    <div v-else>
                      <span>[{{
                        item.releaseTime
                      }}]</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="content-right-sec mar-bot">
            <div class="right-tab">
              <div class="right-text">部门网站</div>
              <div class="right-more"></div>
            </div>
            <div class="work-box">
              <div v-for="(item, index) in elevenList" :key="index">
                <div class="work" @click="goToSec(item)">
                </div>
              </div>
              <div>
                <div class="work1" @click="open1">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-img">
        <div @click="showPhoneNews = !showPhoneNews" class="carousel-inner">
          <vue-j-scroll class="list-style" :steep="1" scrollDirection="left" :data="swirperList" :isRoller="true"
            :rollerScrollDistance="50">
            <div>
              <img v-for="(item, index) in swirperList" :key="'t' + index" :src="item.annexUrl" alt="" />
            </div>
          </vue-j-scroll>
        </div>
      </div>
      <div class="bottom-btn">
        <div class="btn" v-for="(item, index) in hyperlinkList" @click="gowaizhan(item.url)">
          <div class="btn-box hover-underline">
            <img :src="item.iconUrl" alt="" />
            <div class="btn-text" style="margin-top: 11px">{{ item.name }}</div>
          </div>
        </div>
        <!-- <div class="btn" @click="gowaizhan('http://59.255.109.43/xfbzjqsl')">
          <div class="btn-box hover-underline">
            <img
              style="width: 36px; height: 38px"
              src="../../assets/images/apply.png"
              alt=""
            />
            <div class="btn-text">被装申领</div>
          </div>
        </div>
        <div class="btn" @click="gowaizhan('https://wy.cfri.edu.cn/#/home')">
          <div class="btn-box hover-underline">
            <img
              src="../../assets/images/exam.png"
              style="width: 40px; height: 35px"
              alt=""
            />
            <div class="btn-text">在线学习</div>
          </div>
        </div> -->
        <div class="btn" @click="showBusiness()">
          <div class="btn-box hover-underline">
            <img src="../../assets/images/proposal.png" style="width: 36px; height: 38px" alt="" />
            <div class="btn-text">业务系统</div>
          </div>
        </div>
        <!-- <div class="btn">
          <div class="btn-box hover-underline">
            <img
              src="../../assets/images/legal-advice.png"
              style="width: 36px; height: 38px"
              alt=""
            />
            <div class="btn-text">协同报送</div>
          </div>
        </div> -->
        <div class="btn" @click="showBoard = false">
          <div class="btn-box hover-underline">
            <img src="../../assets/images/board.png" style="width: 36px; height: 38px" alt="" />
            <div class="btn-text">火焰蓝热线</div>
          </div>
        </div>
        <div v-if="showPopup" class="popup-box" @mouseover="showPopupTag = true" @mouseleave="show1">
          <ul>
            <li class="li" v-for="(item, index) in popupList" :key="index">
              <span class="hover-underline" @click="gowaizhan(item.url)">{{
                item.name
              }}</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 隐藏框 -->
      <div class="is-show" v-show="isShowImg">
        <span>消防救援局</span><span>芜湖消防救援</span><span>消防救援局</span><span>芜湖消防救援</span>
      </div>
      <div class="is-show-img">
        <img src="../../assets/images/is-show.png" alt="" @click="isShowImg = !isShowImg" />
      </div>
      <div class="linkage">
        <div class="linkage-left">
          <div class="linkage-box">
            <img src="../../assets/images/arrow.png" alt="" />
            <div class="linkage-text hover-underline" @click="gowaizhan('http://59.255.109.9/')">
              国家消防救援局
            </div>
          </div>
          <div class="linkage-box">
            <img src="../../assets/images/arrow.png" alt="" />
            <div class="linkage-text hover-underline" @click="gowaizhan('http://59.203.26.16/index.html')">
              安徽省消防救援总队
            </div>
          </div>
          <div class="linkage-box" @mouseover="showPopup = true" @mouseleave="unShowPopup">
            <img src="../../assets/images/arrow.png" alt="" />
            <div class="linkage-text">本省支队网</div>
          </div>
        </div>
        <!--  -->
      </div>

    </div>
    <div v-if="!showHome">
      <important-news :eletype="eletype" @setCilck="setShow(true)"></important-news>
    </div>
    <div v-if="!showHomes">
      <important-new :eletypes="eletypes" @setCilck="setShow(true)"></important-new>
    </div>
    <div v-if="!showBoard">
      <message-board @setCilck="setShow(true)"></message-board>
    </div>
    <div v-if="!showPhoneNews">
      <photo-news @setCilck="setShow(true)"></photo-news>
    </div>
    <div v-if="!showCleanGover">
      <clean-gover :imgid="imgid" @setCilck="setShow(true)"></clean-gover>
    </div>
    <div v-if="!showTextAll">
      <text-all :textobj="textobj" :ids="ids" @setCilck="setShow(true)"></text-all>
    </div>
    <div v-if="!showSerachInfo">
      <SerachInfo @setCilck="setShow(true)" :searchValue="searchValue"></SerachInfo>
    </div>
    <div v-if="!showSerachInfos">
      <SerachInfos @setCilck="setShow(true)" :searchValues="searchValues"></SerachInfos>
    </div>
    <div v-if="!showDeptList">
      <DeptList @setCilck="setShow(true)" :deptName="deptName"></DeptList>
    </div>
    <div v-if="!ShowBusiness">
      <Business @setCilck="setShow(true)" :otherWeb="otherWeb"></Business>
    </div>
    <!-- <div @click="this.newWindow.close()">sssss</div> -->
    <div class="bottom-info">
      <div class="bottom-box">
        <div>
          <span class="hover-underline" @click="tps(0)">首页</span>
          <span> 丨 </span>
          <span class="hover-underline" @click="tps(1)">地理位置</span>
          <span> 丨 </span>
          <span class="hover-underline" @click="tps(2)">联系我们</span>
          <span> 丨 </span>
          <span class="hover-underline" @click="tps(3)">技术支持</span>
        </div>
        <div>主办单位：池州市消防救援支队</div>
      </div>
    </div>

  </div>
</template>

<script>
import ImportantNews from "./compotents/ImportantNews.vue";
import ImportantNew from "./compotents/ImportantNew.vue";
import MessageBoard from "./compotents/MessageBoard.vue";
import PhotoNews from "./compotents/PhotoNews.vue";
import CleanGover from "./compotents/CleanGover.vue";
import TextAll from "./compotents/zhongd.vue";
import SerachInfo from "./compotents/SerachInfo.vue";
import SerachInfos from "./compotents/SerachInfos.vue";
import DeptList from "./compotents/DeptList.vue";
import Mouse from "./compotents/Mouse.vue";
import Business from "./compotents/Business.vue";
import {
  listAll,
  listduty,
  listdutyconfig,
  listsuspend,
  listhyperlink,
  listwork,
  listzhongdui,
} from "../../api/index";
import axios from "axios";
import { listspecial, listcolumnZt } from "@/api/pop";
export default {
  components: {
    ImportantNews,
    ImportantNew,
    MessageBoard,
    PhotoNews,
    CleanGover,
    TextAll,
    SerachInfo,
    SerachInfos,
    DeptList,
    Mouse,
    Business,
  },
  data() {
    return {
      showPopupTag: false,
      showPopup: false,
      checkwj: 2,
      leftImgList: [
        {
          url: "",
        },
        {
          url: "../../assets/images/leftImg.png",
        },
        {
          url: "../../assets/images/leftImg.png",
        },
      ],
      leftImgShow: true,
      ShowBusiness: true,
      weekday: "",
      searchValue: "",
      elevenShow: true,
      showHome: true,
      showHomes: true,
      currentPage: "",
      showBoard: true,
      showSerachInfo: true,
      showSerachInfos: true,
      showPhoneNews: true,
      showCleanGover: true,
      showTextAll: true,
      showDeptList: true,
      date: "",
      newsDate: "",
      title: "",
      currentIndex: 0,
      interval: null,
      isShowImg: false,
      textobj: {},
      serachValue: "",
      eletype: 0,
      eletypes: 0,
      zeroListTop: [],
      zeroList: [], //消防要闻
      oneListTop: [], //机关文件
      oneList: [], //机关文件
      twoList: [], //机关动态
      threeList: [], //基层动态
      fourList: [], //灾情速递
      fiveList: [], //媒体聚焦
      sixList: [], //调研专题
      sevenList: [], //他山之石
      columnZtList: [], //专题专栏新
      eightList: [], //专题专栏
      nineList: [], //工作简报
      tenList: [], //工作计划
      elevenList: [], //部门网站
      twelveList: [], //会议纪要
      thirteenList: [], //工作督办
      List17: [], //上级文件
      List18: [], //支队文件
      swirperList: [], //轮播图
      bannerList: [], //banner图
      sixteen: [], //banner图
      images: [],
      search: "",
      searchFrom: {
        pageNum: 1,
        pageSize: 999,
      },
      tableList: [],
      topRed: [],
      guichi: [],
      jiuhuashan: [],
      dongzhi: [],
      shitai: [],
      gqingyang: [],
      teqin: [],
      infoList: [],
      ids: "",
      imgid: "",
      searchText: "",
      deptName: "",
      todayDuty: {},
      dutyconfig: [],
      suspendList: [],
      hyperlinkList: [],
      otherWeb: "",
      newWindow: "",
      zhongdui: {},
      popupList: [
        { name: "合肥支队网", url: "http://59.203.34.139/" },
        { name: "芜湖支队网", url: "http://59.203.151.155/" },
        { name: "安庆支队网", url: "http://59.203.218.38/" },
        { name: "六安支队网", url: "http://59.203.228.64/" },
        { name: "宿州支队网", url: "https://59.203.70.7/" },
        { name: "宣城支队网", url: "http://59.203.169.55/" },
        { name: "滁州支队网", url: "http://59.203.54.56/" },
        { name: "亳州支队网", url: "http://59.203.98.80/" },
        { name: "铜陵支队网", url: "http://59.203.209.183/" },
        { name: "黄山支队网", url: "http://59.209.86.181/" },
        { name: "蚌埠支队网", url: "http://59.203.63.45/" },
        { name: "马鞍山支队网", url: "http://59.203.247.200/" },
        { name: "淮南支队网", url: "http://59.203.118.200/" },
        { name: "阜阳支队网", url: "http://59.203.106.65/" },
        { name: "池州支队网", url: "http://59.203.187.199/" },
        { name: "淮北支队网", url: "http://59.203.82.45/index.html" },
        { name: "总队训保支队网", url: "http://59.203.26.16:8089/" },
      ],
      isHovered: false,
      call: '',
    };
  },
  created() {
    this.getlistAll();
    this.getTable();
     this.getCurrentDate();
    this.listdutyconfig();
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("showBoard")) {
      this.showBoard = JSON.parse(params.get("showBoard"));
    }
    // this.ids = params.get("ids");
    // this.imgid = params.get("imgid");
    this.searchValue = params.get("searchValue");
    this.searchValues = params.get("searchValues");
    this.deptName = params.get("deptName");
    this.eletype = params.get("eletype");
    this.eletypes = params.get("eletypes");
    this.call = params.get("call");
    // if (this.ids) {
    //   this.showTextAll = !this.showTextAll;
    // }
    if (this.imgid) {
      this.showCleanGover = !this.showCleanGover;
    }
    if (this.searchValue) {
      this.showSerachInfo = !this.showSerachInfo;
    }
    if (this.searchValues) {
      this.showSerachInfos = !this.showSerachInfos;
    }
    if (this.deptName) {
      this.showDeptList = !this.showDeptList;
    }
    if (this.eletype) {
      this.showHome = !this.showHome;
    }
    if (this.eletypes) {
      this.showHomes = !this.showHomes;
    }
    if (this.call) {
      this.showBoard = !this.showBoard;
    }
    this.getDate();
   
    this.listsuspend();
    this.listhyperlink();
    this.listwork();
  },
  computed: {},
  methods: {
    tps(type) {
      let url
      if (type == 1) {
        url = `/?organization=地理位置`;
      } else if (type == 2) {
        url = `/?call=1`;
      } else if (type == 3) {
        url = `http://www.ahqmkeji.com/aboutus`;
      } else {
        url = `/`;
      }
      window.open(url, "_blank");
    },
    open1() {
      this.$message('当前点击页面开发中！');
      let url = '/CaseLibrary'
      window.open(url, "_blank");
    },
    open2(item) {
      if(item.id == 9){
        window.open(`/Special?id=${encodeURIComponent(item.id)}`, "_blank");
      }else{
        this.$message('当前点击页面开发中！');
      }
    },
    checkwjbt() {
      this.checkwj = 1;
    },
    checkwjbt2() {
      this.checkwj = 2;
    },
    show1() {
      this.showPopup = false;
      this.showPopupTag = false;
    },
    unShowPopup() {
      setTimeout(() => {
        if (!this.showPopupTag) {
          this.showPopup = false;
          // this.this.showPopupTag = false
        }
      }, 500);
    },
    getTable() {
      listspecial({
        pageNum: 1,
        pageSize: 1,
      }).then((res) => {
        this.tableData = res.data.data.list;
        if (this.tableData.length > 0 && this.tableData[0].status == 4) {
          this.openWindow(this.tableData[0]);
        }
      });
    },
    openWindow(item) {
      if (this.newWindow) {
        this.newWindow.close();
      }
      const switchTag = window.sessionStorage.getItem("openWindow");
      if (switchTag) {
        return;
      }
      window.sessionStorage.setItem("openWindow", true);
      // 获取屏幕的宽度和高度
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      // 计算新窗口的位置
      const windowWidth = 1120;
      const windowHeight = 700;
      const windowLeft = (screenWidth - windowWidth) / 2;
      const windowTop = (screenHeight - windowHeight) / 2;
      console.log(item);
      if (item.columnType == 0) {
        this.newWindow = window.open(
          "弹框",
          "",
          `width=${windowWidth},height=${windowHeight},screenX=${windowLeft},top=${windowTop},location=no`
        );
        this.newWindow.document.body.innerHTML = "";
        // 在新窗口中显示内容
        // newWindow.document.write(`<h2>${item.titleContent}</h2>`);
        // newWindow.document.write(`作者：${item.author}`);
        // newWindow.document.write(`来源：${item.source}`);
        // newWindow.document.write(`时间：${item.releaseTime}`);
        this.newWindow.document.write(
          `<h2 style="text-align: center">${item.titleContent}</h2>`
        );
        this.newWindow.document.write(
          `<div style="display: flex; justify-content: center">`
        );
        this.newWindow.document.write(
          `<span style="margin-right: 15px">作者：${item.author}</span>`
        );
        this.newWindow.document.write(
          `<span style="margin-right: 15px">来源：${item.source}</span>`
        );
        this.newWindow.document.write(
          `<span style="margin-right: 15px">时间：${item.releaseTime}</span>`
        );
        this.newWindow.document.write(`</div>`);
        this.newWindow.document.write(
          `<p style="text-indent: 2em;">${item.content}</p>`
        );
      } else if (item.columnType == 1) {
        this.newWindow = window.open(
          item.fileUrl,
          "弹框",
          `width=${windowWidth},height=${windowHeight},screenX=${windowLeft},top=${windowTop},location=no`
        );
      } else if (item.columnType == 2) {
        this.newWindow = window.open(
          item.annexUrl,
          "弹框",
          `width=${windowWidth},height=${windowHeight},screenX=${windowLeft},top=${windowTop},location=no`
        );
      }
    },
    showBusiness() {
      this.otherWeb = 2;
      this.ShowBusiness = !this.ShowBusiness;
    },
    istrue() {
      const searchValue = this.searchValue;
      const url = `/?searchValue=${encodeURIComponent(searchValue)}`;
      window.open(url, "_blank");
    },
    goInfo(item) {
      const ids = item.id;
      let url = `/?ids=${encodeURIComponent(ids)}`;
      if (item.fileUrl) {
        url = item.fileUrl;
      }
      window.open(url, "_blank");
    },
    goimgInfo(item) {
      // 使用window.open方法在新窗口或选项卡中打开链接
      const ids = item.id;
      const url = `/?imgid=${encodeURIComponent(ids)}`;
      window.open(url, "_blank");
    },
    goDept(value) {
      const deptName = value;
      const url = `/?deptName=${encodeURIComponent(deptName)}`;
      window.open(url, "_blank");
    },
    gengduo(type) {
      let eletype = type;
      const url = `/?eletype=${encodeURIComponent(eletype)}`;
      // this.showHome = !this.showHome;
      window.open(url, "_blank");
    },
    getlistAll() {
      // axios.post('/api/message/release/queryList', this.searchFrom).then(res=>{
      // })
      listAll({ pageNum: 1, pageSize: 8, messageType: 0, status: 4 }).then(
        (res) => {
          this.zeroList = res.data.data.list;
          this.zeroList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            // if (item.messageName) {
            //   if (item.messageName.length > 17) {
            //     item.messageNames = item.messageName.slice(0, 16) + "...";
            //   } else {
            //     item.messageNames = item.messageName;
            //   }
            // }
          });
        }
      );
      listAll({ pageNum: 1, pageSize: 9, messageType: 16, status: 4 }).then(
        (res) => {
          this.sixteen = res.data.data.list;
          this.sixteen.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.messageName) {
              if (item.messageName.length > 9) {
                item.messageNames = item.messageName.slice(0, 8) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );
      listAll({ pageNum: 1, pageSize: 8, messageType: 1, status: 4 }).then(
        (res) => {
          this.oneList = res.data.data.list;
          this.oneList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.messageName) {
              if (item.messageName.length > 18) {
                item.messageNames = item.messageName.slice(0, 18) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );
      listAll({ pageNum: 1, pageSize: 8, messageType: 17, status: 4 }).then(
        (res) => {
          this.List17 = res.data.data.list;
          this.List17.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.messageName) {
              if (item.messageName.length > 18) {
                item.messageNames = item.messageName.slice(0, 18) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );
      listAll({ pageNum: 1, pageSize: 8, messageType: 18, status: 4 }).then(
        (res) => {
          this.List18 = res.data.data.list;
          this.List18.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.messageName) {
              if (item.messageName.length > 18) {
                item.messageNames = item.messageName.slice(0, 18) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );
      listAll({ pageNum: 1, pageSize: 8, messageType: 2, status: 4 }).then(
        (res) => {
          this.twoList = res.data.data.list;
          this.twoList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.messageName) {
              if (item.messageName.length > 18) {
                item.messageNames = item.messageName.slice(0, 18) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );
      listAll({ pageNum: 1, pageSize: 5, messageType: 4, status: 4 }).then(
        (res) => {
          this.fourList = res.data.data.list;
          this.fourList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.messageName) {
              if (item.messageName.length > 18) {
                item.messageNames = item.messageName.slice(0, 18) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );
      listAll({ pageNum: 1, pageSize: 5, messageType: 5, status: 4 }).then(
        (res) => {
          this.fiveList = res.data.data.list;
          this.fiveList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.messageName) {
              if (item.messageName.length > 18) {
                item.messageNames = item.messageName.slice(0, 18) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );
      listAll({ pageNum: 1, pageSize: 5, messageType: 6, status: 4 }).then(
        (res) => {
          this.sixList = res.data.data.list;
          this.sixList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.messageName) {
              if (item.messageName.length > 18) {
                item.messageNames = item.messageName.slice(0, 18) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );
      listAll({ pageNum: 1, pageSize: 5, messageType: 7, status: 4 }).then(
        (res) => {
          this.sevenList = res.data.data.list;
          this.sevenList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.messageName) {
              if (item.messageName.length > 18) {
                item.messageNames = item.messageName.slice(0, 18) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );
      // listAll({ pageNum: 1, pageSize: 8, messageType: 8, status: 4 }).then(
      //   (res) => {
      //     this.eightList = res.data.data.list;
      //     this.eightList.map((item) => {
      //       if (item.releaseTime) {
      //         item.releaseTime = item.releaseTime.slice(5, 10);
      //       }
      //       if (item.messageName) {
      //         if (item.messageName.length > 18) {
      //           item.messageName = item.messageName.slice(0, 18) + "...";
      //         }
      //       }
      //     });
      //   }
      // );
      listAll({ pageNum: 1, pageSize: 7, messageType: 9, status: 4 }).then(
        (res) => {
          this.nineList = res.data.data.list;
          this.nineList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.messageName) {
              if (item.messageName.length > 9) {
                item.messageNames = item.messageName.slice(0, 8) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );
      listAll({ pageNum: 1, pageSize: 5, messageType: 10, status: 4 }).then(
        (res) => {
          this.tenList = res.data.data.list;
          this.tenList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.messageName) {
              if (item.messageName.length > 9) {
                item.messageNames = item.messageName.slice(0, 8) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );

      listAll({ pageNum: 1, pageSize: 8, messageType: 12, status: 4 }).then(
        (res) => {
          this.twelveList = res.data.data.list;
          this.twelveList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }

            if (item.messageName) {
              if (item.messageName.length > 8) {
                item.messageNames = item.messageName.slice(0, 8) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );
      listAll({ pageNum: 1, pageSize: 8, messageType: 13, status: 4 }).then(
        (res) => {
          this.thirteenList = res.data.data.list;
          this.thirteenList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.messageName) {
              if (item.messageName.length > 8) {
                item.messageNames = item.messageName.slice(0, 8) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );
      listAll({ pageNum: 1, pageSize: 10, messageType: 14, status: 4 }).then(
        (res) => {
          this.swirperList = res.data.data.list;
        }
      );
      listAll({ pageNum: 1, pageSize: 5, messageType: 15, status: 4 }).then(
        (res) => {
          this.bannerList = res.data.data.list;
          this.bannerList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.messageName) {
              if (item.messageName.length > 16) {
                item.messageNames = item.messageName.slice(0, 16) + "...";
              } else {
                item.messageNames = item.messageName;
              }
            }
          });
        }
      );
      listAll({
        pageNum: 1,
        pageSize: 5,
        messageType: 3,
        status: 4,
        deptName: 0,
      }).then((res) => {
        this.guichi = res.data.data.list;
        this.guichi.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.messageName) {
            if (item.messageName.length > 16) {
              item.messageNames = item.messageName.slice(0, 15) + "...";
            } else {
              item.messageNames = item.messageName;
            }
          }
        });
      });
      listAll({
        pageNum: 1,
        pageSize: 5,
        messageType: 3,
        status: 4,
        deptName: 1,
      }).then((res) => {
        this.shitai = res.data.data.list;
        this.shitai.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.messageName) {
            if (item.messageName.length > 16) {
              item.messageNames = item.messageName.slice(0, 15) + "...";
            } else {
              item.messageNames = item.messageName;
            }
          }
        });
      });
      listAll({
        pageNum: 1,
        pageSize: 5,
        messageType: 3,
        status: 4,
        deptName: 2,
      }).then((res) => {
        this.jiuhuashan = res.data.data.list;
        this.jiuhuashan.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.messageName) {
            if (item.messageName.length > 16) {
              item.messageNames = item.messageName.slice(0, 15) + "...";
            } else {
              item.messageNames = item.messageName;
            }
          }
        });
      });
      listAll({
        pageNum: 1,
        pageSize: 5,
        messageType: 3,
        status: 4,
        deptName: 3,
      }).then((res) => {
        this.dongzhi = res.data.data.list;
        this.dongzhi.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.messageName) {
            if (item.messageName.length > 16) {
              item.messageNames = item.messageName.slice(0, 15) + "...";
            } else {
              item.messageNames = item.messageName;
            }
          }
        });
      });
      listAll({
        pageNum: 1,
        pageSize: 5,
        messageType: 3,
        status: 4,
        deptName: 4,
      }).then((res) => {
        this.qingyang = res.data.data.list;
        this.qingyang.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.messageName) {
            if (item.messageName.length > 16) {
              item.messageNames = item.messageName.slice(0, 15) + "...";
            } else {
              item.messageNames = item.messageName;
            }
          }
        });
      });
      listAll({
        pageNum: 1,
        pageSize: 5,
        messageType: 3,
        status: 4,
        deptName: 5,
      }).then((res) => {
        this.teqin = res.data.data.list;
        this.teqin.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.messageName) {
            if (item.messageName.length > 16) {
              item.messageNames = item.messageName.slice(0, 15) + "...";
            } else {
              item.messageNames = item.messageName;
            }
          }
        });
      });

      this.startCarousel();
    },
    bannerBtn() {
      this.bannerobj = this.bannerList[this.currentIndex];
      this.showCleanGover = !this.showCleanGover;
    },
    gengduoWeb(type) {
      this.ShowBusiness = !this.ShowBusiness;
      this.otherWeb = type;
    },

    setShow(value) {
      this.showHome = value;
      this.showHomes = value;
      this.showBoard = value;
      this.showPhoneNews = value;
      this.showCleanGover = value;
      this.showTextAll = value;
      this.showSerachInfo = value;
      this.showDeptList = value;
      this.ShowBusiness = value;
    },
    toggleView() {
      this.elevenShow = true;
    },
    toggleViews() {
      this.elevenShow = false;
    },
    getDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const date = today.getDate();
      const weekday = today.getDay();
      const weekdays = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];

      this.weekday = weekdays[weekday];

      console.log(`今天是${year}年${month}月${date}日`);
      this.date = `${year}年${month}月${date}日`;
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，所以加1
      const day = String(date.getDate()).padStart(2, "0");

      const days = `${year}-${month}-${day}`;
      this.newsDate = `${month}-${day}`;
      listduty({ dutyTime: days, pageNum: 1, pageSize: 10 }).then((res) => {
        this.todayDuty = res.data.data.list[0];
      });
    },
    listdutyconfig() {
      listdutyconfig({ type: 0, pageNum: 1, pageSize: 10 }).then((res) => {
        this.dutyconfig = res.data.data.list;
      });
    },
    listsuspend() {
      listsuspend({ pageNum: 1, pageSize: 10, status: "0" }).then((res) => {
        this.suspendList = res.data.data.list;
      });
    },
    pauseAnimation() {
      const element = document.getElementById("floatingWindow");
      element.style.animationPlayState = "paused";
    },
    resumeAnimation() {
      const element = document.getElementById("floatingWindow");
      element.style.animationPlayState = "running";
    },
    listwork() {
      listwork({ pageNum: 1, pageSize: 10, status: "0" }).then((res) => {
        this.elevenList = res.data.data.list;
        console.log(this.elevenList, "elevenList");
      });
      listcolumnZt({ pageNum: 1, pageSize: 3, status: "0" }).then((res) => {
        this.columnZtList = res.data.data.list;
        console.log(this.columnZtList, "columnZtList");
      });
    },
    listhyperlink() {
      listhyperlink({ pageNum: 1, pageSize: 10, status: "0" }).then((res) => {
        this.hyperlinkList = res.data.data.list;
        console.log(this.hyperlinkList, "hyperlinkList");
      });
    },
    nextSlide() {
      this.currentIndex++;
      if (this.currentIndex >= this.bannerList.length) {
        this.currentIndex = 0;
      }
    },
    startCarousel() {
      this.interval = setInterval(this.nextSlide, 3000);
    },
    stopCarousel() {
      clearInterval(this.interval);
    },

    // 点击专项工作去二级页面
    goToSec(index) {
      // window.open("./specialWork", "_blank");
      const url = new URL("./specialWork", window.location.origin);
      url.searchParams.append("param", index.id); // 添加查询参数
      window.open(url.toString(), "_blank");
      // if (index == 0) {
      //   this.$router.push("./specialWork");
      // }
    },
    // 点击专题专栏工作去二级页面
    goToColZt(index) {
      const url = new URL("./columnZtWindow", window.location.origin);
      url.searchParams.append("param", index.id); // 添加查询参数
      window.open(url.toString(), "_blank");
    },
    // 点击专项工作去二级页面
    goToCol(index) {
      const url = new URL("./columnWindow", window.location.origin);
      url.searchParams.append("param", index.id); // 添加查询参数
      window.open(url.toString(), "_blank");
    },
    gowaizhan(url) {
      window.open(url, "_blank");
    },
  },
  beforeDestroy() {
    this.stopCarousel();
  },
};
</script>

<style scoped lang="scss">
@keyframes moveDownRight {
  0% {
    transform: translate(0, 0);
  }

  25% {
    /* transform: translate(-100px, -100px); */
    transform: translate(calc((100% - 1060px) / 4), -200px);
  }

  50% {
    transform: translate(-200px, 0px);
  }

  75% {
    transform: translate(-100px, 200px);
  }

  100% {
    transform: translate(0, 0);
  }
}

.popup-box {
  position: absolute;
  bottom: 0;
  // left: -112px;
  width: 100%;
  border-top: #0e67ab solid 2px;
  background-color: #fff;

  ul {
    width: 1120px;
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .li {
    width: 22%;
    margin-bottom: 10px;
    margin-left: 10px;
  }
}

.container {
  position: relative;
  width: 1120px;
  margin: 0 auto;
  background: #fff;
}

.indicator {
  color: #fff;
}

.top {
  width: 55%;
  height: 277px;
  margin: 0 auto;

  img {
    width: 55%;
    height: 277px;
  }
}

::v-deep .el-input__inner {
  height: 28px;
  border-radius: 0;
}

::v-deep .el-input__icon {
  line-height: 28px;
}

.leftImgOLD {
  position: absolute;
  left: -132px;
  top: 660px;

  img {
    width: 120px;
    height: 40px;
  }
}

.leftImg {
  position: fixed;
  top: 50%;
  left: calc((100% - 1120px) / 2 - 120px);
  /* transform: translateY(-50%); */
  z-index: 9999;
  animation-name: moveDownRight;
  animation-duration: 9s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  img {
    width: 200px;
    height: 60px;
  }
}

.no-animation {
  animation: none !important;
}

.date {
  width: 1120px;
  // padding: 16px auto;
  // margin-bottom: 16px;
  font-size: 14px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .dateWidth {
    width: 116px;
    text-align: center;
  }

  .red {
    color: #e71111;
  }

  .linkage-right {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 136px;

    input {
      width: 110px;
      height: 24px;
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #2b56ac;
    }

    .linkage-right2 {
      width: 136px;
    }

    .no-outline-input {
      outline: none;
    }

    .no-outline-input:focus {
      border-color: #2b56ac;
    }

    .button {
      width: 24px;
      height: 28px;
      background: #2b56ac;
      border-radius: 0px 4px 4px 0px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 11px;
        height: 12px;
      }
    }
  }
}

.custom-list {
  list-style-type: none;
  padding: 0 12px;
  margin: 0;
}

.custom-lists li {
  position: relative;
  padding-left: 18px;
  margin: 7px 0;
  pointer-events: none;
}

.custom-lists li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  background-color: #c1c5cd;
  border-radius: 50%;
}

.custom-lists {
  list-style-type: none;
  padding: 0 12px;
  margin: 0;
}

.custom-list li {
  position: relative;
  padding-left: 18px;
  margin: 10px 0;
  pointer-events: none;
}

.custom-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  background-color: #c1c5cd;
  border-radius: 50%;
}

.li-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  pointer-events: none;

  .red {
    display: inline-block;
    width: 48px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background: #ffdfdf;
    border-radius: 4px;
    font-size: 10px;
    color: #cc0000;
    // margin-left: 10px;
  }
}

.custom-link {
  // margin-right: 8px;
  color: inherit;
  text-decoration: none;
  pointer-events: all;
}

.content {
  width: 1120px;
  margin: 0 auto;
  // display: flex;
  // justify-content: flex-start;

  .content-left-top {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: start;
  }

  .swiper {
    width: 36%;
    height: 290px;
    margin-left: 12px;

    .carousel {
      position: relative;
      width: 100%;
      height: 268px;
      overflow: hidden;
    }

    .carousel-image img {
      width: 100%;
      height: 268px;
    }

    .indicators {
      position: absolute;
      right: 10px;
      bottom: 10px;
      display: flex;
    }

    .indicators span {
      display: inline-block;
      width: 17px;
      height: 17px;
      margin: 0 5px;
      background: #9a8880;
      text-align: center;
      line-height: 17px;
      cursor: pointer;
    }

    .indicators span.active {
      background: #e4730d;
    }
  }

  .title {
    width: 100%;
    height: 25px;
    text-align: center;
    background: #5f5f5f;
    color: #fff;
  }

  .sec-right {
    width: 38%;
    height: 290px;
    margin-left: 12px;

    .important-news-text {
      width: 100%;
      text-align: center;
      margin-top: 12px;
      margin-bottom: 32px;
    }
  }

  .sec-right-title {
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  .leftbc {
    width: 50%;
  }

  .more-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    right: 0;
    bottom: 2px;
    color: #2e5bb6;
    cursor: pointer;
  }

  .more {
    margin-right: 12px;
    margin-bottom: 5px;
  }

  .tag {
    width: 100%;
    position: relative;

    img {
      margin-top: 3px;
      width: 100%;
      height: 30px;
    }

    span {
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      height: 24px;
      top: 8px;
      left: 16px;
      position: absolute;
    }

    .wenjian {
      font-weight: bold;
      font-size: 16px;
      display: flex;
      height: 24px;
      line-height: 32px;
      text-align: center;
      top: 3px;
      left: 0px;
      position: absolute;

      .shangji {
        width: 108px;
        height: 30px;
        color: #fff;
        margin-right: 16px;
        background-image: url("../../assets/images/leftYes.png");
      }

      .shangji2 {
        width: 108px;
        height: 30px;
        color: #2b56ac;
        margin-right: 16px;
        background-image: url("../../assets/images/leftNone.png");
      }

      .zhidui {
        width: 108px;
        height: 30px;
        color: #2b56ac;
        background-image: url("../../assets/images/leftNone.png");
      }

      .zhidui2 {
        width: 108px;
        height: 30px;
        color: #fff;
        background-image: url("../../assets/images/leftYes.png");
      }
    }
  }

  .long-tag {
    img {
      width: 100%;
    }
  }

  .important-news-text {
    font-weight: bold;
    font-size: 14px;
    color: #e71111;
  }

  .content-left-sec {
    width: 100%;
    margin-top: 12px;
    display: flex;
    justify-content: center;
    align-items: start;
  }

  .content-left-sec-left {
    width: 38%;
    height: 164px;
  }

  .thr {
    width: 100%;
  }

  .content-left-thr {
    width: 100%;
    height: 222px;
    display: flex;
    justify-content: center;
    align-items: start;
  }

  .my-li {
    margin: 8px 0;
  }

  .content-left-thr-content {
    display: flex;
    justify-content: center;
    height: 406px;
  }

  .content-left-right {
    margin-left: 14px;
  }

  .content-left-thr-left {
    width: 50%;
    height: 200px;

    .row {
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }

    .row-left {
      display: flex;
      justify-content: space-between;
      padding: 0;
      width: 52px;
      margin-top: 8px;
      font-size: 14px;
      font-weight: bold;
      color: #e71111;
    }

    .row-right {
      width: 80%;
      height: 136px;
      margin-left: 8px;
    }
  }

  .content-left-four {
    width: 60%;
    height: 164px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .mar-bot {
    margin-bottom: 8px;
  }

  .content-right-top {
    width: 24%;
    height: 250px;
    padding-right: 12px;

    .top-text {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      overflow: hidden;
    }

    .blue {
      font-weight: bold;
      width: 100%;
      height: 30px;
      text-align: center;
      line-height: 30px;
      font-size: 16px;
      margin-left: 12px;
      background-color: #f0f0f0;
      color: #2b56ac;
      cursor: pointer;
    }

    .active {
      width: 100%;
      height: 30px;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 30px;
      background: linear-gradient(to bottom, #3364c5, #1e4188);
    }
  }

  .content-right-sec {
    width: 24%;
    height: 260px;
    padding-right: 12px;
  }

  .right-tab {
    width: 100%;
    height: 30px;
    color: #ffffff;
    padding: 0 12px;
    background: linear-gradient(to bottom right, #628fe8, #214690);
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }

  .work-box {
    width: 90%;
    height: 130px;
    margin: 0 5%;
  }

  .dispFSb {
    display: flex;
    justify-content: space-between;
  }

  .work {
    width: 225px;
    height: 65px;
    font-weight: bold;
    font-size: 18px;
    text-align: center;
    line-height: 26px;
    color: #2E5BB6;
    margin: 10px 0;
    cursor: pointer;
    background-image: url("../../assets/images/zgw.png");
  }

  .work1 {
    width: 225px;
    height: 65px;
    font-weight: bold;
    font-size: 18px;
    text-align: center;
    line-height: 26px;
    color: #2E5BB6;
    cursor: pointer;
    background-image: url("../../assets/images/mh.png");
  }

  .content-right-five {
    width: 248px;
    height: 176px;
  }

  .right-text {
    font-weight: bold;
    font-size: 16px;
  }

  .right-more {
    font-size: 12px;
    cursor: pointer;
  }
}

.swiper-img {
  width: 1120px;
  height: 140px;
  margin: 0 auto;
  margin-top: 12px;

  .carousel-inner img {
    width: 210px;
    height: 140px;
    margin: 0 10px;
  }
}

.bottom-btn {
  width: 1120px;
  height: 154px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;

  .btn {
    width: 96px;
    height: 110px;
    background: #ffffff;
    box-shadow: 2px 2px 12px 1px rgba(153, 153, 153, 0.24);
    border-radius: 16px 16px 16px 16px;
    display: flex;
    justify-content: center;
    align-items: center;

    .btn-box {
      text-align: center;
    }

    img {
      width: 36px;
      height: 38px;
    }

    .btn-text {
      margin-top: 5px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.dataBox {
  padding-top: 12px;
}

.is-show {
  width: 1120px;
  height: 72px;
  border: 1px solid #2e5bb6;
  padding: 14px 0 0 14px;
  box-sizing: border-box;
  margin-top: -72px;
  margin-bottom: -10px;
  position: relative;
  background: #fff;
  z-index: 2;
  margin: 0 auto;

  span {
    color: #2e5bb6;
    margin-right: 28px;
  }
}

.is-show-img {
  cursor: pointer;
  width: 1120px;
  height: 4px;
  margin: 0 auto;

  img {
    width: 100%;
    height: 4px;
  }
}

.zhuantu {
  height: 55px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  /* 水平居中对齐 */
  justify-content: center;
  /* 可选：垂直居中对齐，确保容器大小足够大 */
  text-align: center;
  background-size: 100% 100%;
  color: #000;
}

.linkage {
  width: 1120px;
  height: 70px;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  margin: 0 auto;
  box-sizing: border-box;

  .linkage-left {
    width: 730px;
    display: flex;
    // justify-content: space-between;
    align-items: center;

    .linkage-box {
      display: flex;
      justify-content: center;
      align-items: center;

      // height: 100%;
      img {
        width: 23px;
        height: 20px;
        margin-right: 16px;
      }
    }
  }

  .linkage-text {
    font-weight: bold;
    font-size: 16px;
    color: #2b56ac;
    margin-right: 60px;
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: linear-gradient(180deg, #0E67AB 0%, #073456 100%);
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}

.close {
  width: 200px;
  text-align: end;
  font-size: 12px;
  color: #333;

  img {
    width: 8px;
    height: 8px;
  }
}

.shou {
  cursor: pointer;
  /* 鼠标悬停时显示手形光标 */
}

.hover-underline {
  cursor: pointer;
  /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline;
  /* 悬停时添加下划线 */
}

.hover-underlines {
  cursor: pointer;
  /* 鼠标悬停时显示手形光标 */
}

.hover-underlines:hover {
  // text-decoration: underline; /* 悬停时添加下划线 */
  border-bottom: 1px solid #e71137;
}

.custom-link-zero {
  width: 316px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-link-text {
  width: 310px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-link-text2 {
  width: 252px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-link-text3 {
  width: 206px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
